"use strict";

var React = require('react');

var PropTypes = require('prop-types');

var uniq = require('lodash/uniq');

var flattenDeep = require('lodash/flattenDeep');

var _require = require('../../helpers'),
    isLetterpressComponent = _require.isLetterpressComponent;

function PrintJobPaperTypes(_ref) {
  var printJob = _ref.printJob,
      variant = _ref.variant;
  var filterer = variant === 'letterpress' ? isLetterpressComponent : function (comp) {
    return !isLetterpressComponent(comp);
  };
  var paper_types = uniq(flattenDeep(printJob.products.map(function (product) {
    return product.components.filter(filterer).map(function (_ref2) {
      var paper = _ref2.paper;
      return paper;
    });
  }))).filter(function (str) {
    return str;
  });
  return /*#__PURE__*/React.createElement("span", null, "Paper: ", paper_types.join(', ').toUpperCase());
}

PrintJobPaperTypes.defaultProps = {
  variant: 'digital'
};
PrintJobPaperTypes.propTypes = {
  printJob: PropTypes.shape({
    products: PropTypes.array.isRequired
  }).isRequired,
  variant: PropTypes.oneOf(['letterpress', 'digital'])
};
module.exports = PrintJobPaperTypes;